import classNames from "classnames";
import { ReadOnlyField } from "PFComponents/read_only_field";

import css from "../modals.module.scss";

type RoleInformationRowProps = {
  data: {
    label: string;
    value: string;
  }[];
};

export const RoleInformationRow = ({ data }: RoleInformationRowProps) => (
  <div className={classNames(css.informationRow, { [css.twoColumns]: data.length === 2 })}>
    {data.map(({ label, value }, index) => (
      <ReadOnlyField key={`${label}-${value}-${index}`} label={label} value={value} />
    ))}
  </div>
);
